export default function isServer() {
  return navigator.userAgent.includes('Node.js');
}